import { useAtom } from 'jotai';
import { useEffect, useRef } from 'react';

import type { PrimitiveAtom } from 'jotai';

export const useRegisterPageAction = (
    atom: PrimitiveAtom<(() => Promise<boolean>) | null>,
    callback: () => Promise<boolean>,
) => {
    const [, setPageAction] = useAtom(atom);
    const callbackRef = useRef(callback);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        setPageAction(() => () => callbackRef.current());

        return () => {
            setPageAction(null);
        };
    }, [setPageAction]);
};
